/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Errordescription2Inputs */

const en_notificationcenter_errordescription2 = /** @type {(inputs: Notificationcenter_Errordescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load your notifications.`)
};

/**
* | output |
* | --- |
* | "Couldn't load your notifications." |
*
* @param {Notificationcenter_Errordescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_errordescription2 = /** @type {((inputs?: Notificationcenter_Errordescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Errordescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_errordescription2(inputs)
});
export { notificationcenter_errordescription2 as "notificationCenter_errorDescription" }